import { GroupCalendarViewRouteParameters, USER_CALENDAR_VIEW_TYPE_ROUTE } from './calendarRoutes';
import viewRouteHandler from './viewRouteHandler';
import { CalendarEndpointType, initializeCalendarsCache } from 'owa-calendar-cache-loader';
import {
    selectCalendarWithId,
    restoreSelectedCalendars,
} from 'owa-calendar-surface-select-calendar';

let groupCalendarRouteParams: GroupCalendarViewRouteParameters = null;

export default async function groupCalendarRouteHandler(
    parameters: GroupCalendarViewRouteParameters
): Promise<void> {
    if (!parameters.view) {
        // We use this so that use preferred view type is used
        parameters.view = USER_CALENDAR_VIEW_TYPE_ROUTE;
    }
    // force fall back to surface view type if user's preferred view is not surface
    // TODO: VSO #93977: Rationalize module routing when canvas view type is explicitly specified for surface-only routes
    parameters.forceSurfaceViewType = true;

    // Set the groupCalendarRouteParams so that if we generate the default route
    // then we generate the group route
    groupCalendarRouteParams = parameters;
    viewRouteHandler(parameters);
    await initializeCalendarsCache(CalendarEndpointType.OutlookGroup);
    restoreSelectedCalendars();

    const { groupDomain, groupAlias } = parameters;
    const groupSMTPAddress = `${groupAlias}@${groupDomain}`;

    const isSelected = await selectCalendarWithId(groupSMTPAddress);

    if (!isSelected) {
        // If no calendar was selected then it means the group does not exist
        // so we clear the params, which will make sure that next time the default
        // route is generated it is not the group route
        groupCalendarRouteParams = null;
    }
}

export type GroupCalendarRouteInfo =
    | { isGroupCalendarRoute: true; routeInfo: { groupDomain: string; groupAlias: string } }
    | { isGroupCalendarRoute: false; routeInfo: null };

export function isGroupCalendarRoute(): GroupCalendarRouteInfo {
    if (groupCalendarRouteParams) {
        return {
            isGroupCalendarRoute: true,
            routeInfo: {
                groupDomain: groupCalendarRouteParams.groupDomain,
                groupAlias: groupCalendarRouteParams.groupAlias,
            },
        };
    }

    return { isGroupCalendarRoute: false, routeInfo: null };
}
